// extracted by mini-css-extract-plugin
export default {"headerLeftSide":"MMJwga","headerTop":"EGi0wV","linkWrapper":"YXW3Mv","link":"XLZIgM","name":"wWG_ub","bulletSeparator":"E0geFj","timeAgo":"_P9uLq","badge":"USwhc3"};